<template>
	<div style="position: relative;">
		<auth-modal></auth-modal>
		<search-modal></search-modal>
		<app-header v-if="$route.meta.hideHeaderFooter !== true"></app-header>
		<main>
			<transition name="fade" mode="out-in">
				<router-view :key="$route.fullPath"></router-view>
			</transition>
		</main>
		<app-footer v-if="$route.meta.hideHeaderFooter !== true && $route.meta.hideFooter !== true && $route.name !== 'evento-checkout'"></app-footer>
		<transition name="fade">
			<div class="app-loader" v-if="cargando">
				<img src="./assets/logos/LineUp_Logo_Animado.gif" alt="LineUp Tickets">
			</div>
		</transition>
	</div>
</template>

<script>
	import { mapState }  from 'vuex';
	import Header from './components/shared/Header.vue';
	import Footer from './components/shared/Footer.vue';
	import AuthModal from './components/AuthModal.vue';
	import SearchModal from './components/SearchModal.vue';

	export default {
		computed: {
			...mapState([
				'cargando'
			])
		},
		components: {
			'app-header': Header,
			'app-footer': Footer,
			'auth-modal': AuthModal,
			'search-modal': SearchModal
		},
		metaInfo: {
			title: 'Be There.',
			titleTemplate: 'LineUp Tickets 🎟 %s',
			meta: [
				{ property: 'og:title', content: 'LineUp Tickets. Tu boleto de entrada a los eventos más emocionantes', vmid: 'og:title' },
				{ property: 'og:description', content: 'Con LineUp Tickets encontrá y asegura tu entrada para disfrutar al máximo de los mejores eventos en un solo lugar y de manera fácil y rápida', vmid: 'og:description' },
				{ property: 'og:url', content: 'https://lineuptickets.com/', vmid: 'og:url' },
				{ property: 'og:image', content: 'https://lineuptickets.com/images/lineup-og.jpg', vmid: 'og:image' },
				{ property: 'og:image:alt', content: 'LineUp Tickets. Tu boleto de entrada a los eventos más emocionantes', vmid: 'og:image:alt' },
				{ name: 'twitter:title', content: 'LineUp Tickets. Tu boleto de entrada a los eventos más emocionantes', vmid: 'twitter:title' },
				{ name: 'witter:description', content: 'Con LineUp Tickets encontrá y asegura tu entrada para disfrutar al máximo de los mejores eventos en un solo lugar y de manera fácil y rápida', vmid: 'witter:description' },
				{ name: 'twitter:image', content: 'https://lineuptickets.com/images/lineup-og.jpg', vmid: 'twitter:image' },
				{ name: 'twitter:image:alt', content: 'LineUp Tickets. Tu boleto de entrada a los eventos más emocionantes', vmid: 'twitter:image:alt' },
			]
		},
		methods: {
		},
		async mounted(){
			document.onreadystatechange = () => {
				if(document.readyState == 'complete'){
					this.$store.dispatch('cargando', false);
				} else {
					this.$store.dispatch('cargando', true);
				}
			}
		}
	}
</script>

<style lang="scss">
	section{
		width: 100%;
		position: relative;
	}

	.container{
		position: relative;
		max-width: 1360px;
		width: 100%;
		margin: 0px auto;
		padding: 0px 15px;
		box-sizing: border-box;
		z-index: 1;

		&.container-sm{
			max-width: 1160px;
		}

		// @media screen and (max-width: 1200px){
		// 	max-width: 1140px;
		// }

		// @media screen and (max-width: 992px){
		// 	max-width: 960px;
		// }

		// @media screen and (max-width: 768px){
		// 	max-width: 720px;
		// }

		// @media screen and (max-width: 576px){
		// 	max-width: 540px;
		// }
	}

	.container-fluid{
		width: 100%;
		padding-right: 60px;
		padding-left: 60px;
		margin-right: auto;
		margin-left: auto;

		@media screen and (max-width: 850px){
			padding-right: 20px;
			padding-left: 20px;
		}
	}

	.row{
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-right: -15px;
		margin-left: -15px;
	}

	.fade-enter-active, .fade-leave-active {
		@include transition(opacity .15s);
	}

	.fade-enter, .fade-leave-to {
		opacity: 0
	}

	.scale-enter-active,
	.scale-leave-active {
		@include transition(all .2s);
	}
	.scale-enter,
	.scale-leave-active {
		opacity: 0;
		transform: scale(0.1) translateY(24px);
	}

	.app-loader{
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		margin: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 999;
		background-color: var(--color-secondary);
		@include transition(all .2s);

		img{
			width: 120px;
			height: auto;
		}
	}

	.Vue-Toastification__toast{
		box-shadow: none !important;
		min-height: 52px !important;
		padding: 14px 20px !important;
		margin-bottom: 10px !important;
	}

	.Vue-Toastification__toast--error{
		background-color: var(--color-primary) !important;
	}

	.Vue-Toastification__icon{
		color: var(--color-darker);
	}

	.Vue-Toastification__toast-body{
		color: var(--color-darker) !important;
		font-family: var(--font-sora) !important;
		font-size: 13px !important;
		// text-transform: uppercase;
		font-weight: bold;
	}

	.Vue-Toastification__close-button{
		color: var(--color-darker) !important;
	}
	.Vue-Toastification__progress-bar{
		background-color: var(--color-darker) !important;
	}

	.react-code-input-container{
		width: 100% !important;
		@include flex(row, space-between, center);

		.react-code-input{
			width: 100% !important;
			@include flex(row, space-between, center);

			&>input{
				border: none !important;
				width: 100% !important;
				padding: 0px !important;
				font-family: var(--font-inter) !important;
				font-size: 24px !important;
				font-weight: var(--fw-700) !important;
				line-height: 1.4em !important;
				color: var(--color-darker) !important;
				border-radius: 8px !important;
				height: 64px !important;
				width: 15% !important;
				outline: none !important;
				text-align: center !important;
				box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset !important;

				&:focus-within {
					@include transitionImportant(all .2s);
					box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset !important;
				}

				&:focus{
					caret-color: inherit !important;
				}
			}
		}
	}

	.vue-phone-number-input{
		width: 100% !important;

		.select-country-container{
			width: 94px !important;
			max-width: 94px !important;
			min-width: 94px !important;
			flex: 0 0 94px !important;
			@include flex(row, flex-start, center);

			.country-selector{
				width: 100%;
				@include flex(row, flex-start, center);

				.country-selector__country-flag{
					top: 50%;
					transform: translateY(-50%);
					left: 10px;
				}

				.country-selector__input{
					padding: 0px !important;
					padding-left: 36px !important;
					border: none !important;
					box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
					border-radius: 8px 0px 0px 8px !important;
					font-family: var(--font-inter);
					font-size: 13px !important;
					font-weight: var(--fw-500);
					line-height: 1.4em !important;
					height: 44px !important;

					@media screen and (max-height: 810px){
						height: 40px !important;
					}
				}

				.country-selector__toggle{
					@include flex(row, flex-end, center);
					top: calc(50% - 10px);
					height: 20px;
				}

				.country-selector__label{
					display: none;
				}

				&.is-focused{
					.country-selector__input{
						box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset !important;
						-webkit-box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset !important;
					}
				}
			}
		}

		.flex-1{
			.input-tel{
				height: 44px !important;
				min-height: 44px !important;

				@media screen and (max-height: 810px){
					height: 40px !important;
					min-height: 40px !important;
				}

				.input-tel__input{
					height: 44px !important;
					min-height: 44px !important;
					padding-top: 0px !important;
					font-family: var(--font-inter);
					font-size: 14px !important;
					font-weight: var(--fw-400);
					line-height: 1.4em !important;
					border: none !important;
					box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
					border-radius: 0px 8px 8px 0px !important;

					@media screen and (max-height: 810px){
						height: 40px !important;
						min-height: 40px !important;
					}

					&::placeholder {
						color: #9aa5b5;
						opacity: 1;
						font-family: var(--font-inter);
						font-size: 14px !important;
						font-weight: var(--fw-400);
						line-height: 1.4em !important;
					}

					&:-ms-input-placeholder {
						color: #9aa5b5;
						font-family: var(--font-inter);
						font-size: 14px !important;
						font-weight: var(--fw-400);
						line-height: 1.4em !important;
					}

					&::-ms-input-placeholder {
						color: #9aa5b5;
						font-family: var(--font-inter);
						font-size: 14px !important;
						font-weight: var(--fw-400);
						line-height: 1.4em !important;
					}
				}

				.input-tel__label{
					display: none !important;
				}

				&.has-value{
					.input-tel__input{
						padding-top: 0px !important;
					}
				}

				&.is-focused{
					.input-tel__input{
						box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset !important;
						-webkit-box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset !important;
					}
				}
			}
		}

		&.form-input--error{
			.select-country-container{
				.country-selector{
					.country-selector__input{
						box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
					}

					&.is-focused{
						.country-selector__input{
							box-shadow: var(--color-red-error) 0px 0px 0px 2px inset !important;
							-webkit-box-shadow: var(--color-red-error) 0px 0px 0px 2px inset !important;
						}
					}
				}
			}

			.flex-1{
				.input-tel{
					.input-tel__input{
						box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
					}

					&.is-focused{
						.input-tel__input{
							box-shadow: var(--color-red-error) 0px 0px 0px 2px inset !important;
							-webkit-box-shadow: var(--color-red-error) 0px 0px 0px 2px inset !important;
						}
					}
				}
			}
		}
	}

	.v-select{
		width: 100%;

		.vs__dropdown-toggle{
			padding: 12px 8px 12px 14px;
			font-size: 13px;
			font-weight: var(--fw-500);
			line-height: 1em;
			width: 100%;
			border: none;
			border-radius: 8px;
			box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
			height: 44px;
			align-items: center;
			justify-content: space-between;

			.vs__selected-options{
				padding: 0;
				max-width: calc(100% - 26px);
				overflow: hidden;

				.vs__selected{
					margin: 0;
					padding: 0;
					line-height: 1.4em;
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
					padding-right: 4px;
					display: inline-block;
				}

				.vs__search, .vs__search:focus{
					padding: 0;
					margin: 0;
					width: 0;
					height: 0;
					flex-grow: initial;
				}
			}

			.vs__actions{
				padding: 0;
				@include flex(row, flex-end, center);

				.vs__clear{
					margin-right: 0px;
					display: flex;
					align-items: center;
					justify-content: flex-end;
				}
			}

			@media screen and (max-height: 810px){
				height: 40px;
			}
		}

		.vs__dropdown-menu{
			padding: 8px 0px;
			border: 1px solid #b0b0b0;
			border-radius: 8px;
			box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);
			top: calc(100% + 5px);

			.vs__dropdown-option{
				margin: 0px 6px;
				border-radius: 4px;
				padding: 4px 10px;
				color: var(--color-darker);
				font-size: 14px;
				font-weight: var(--fw-500);

				&.vs__dropdown-option--highlight{
					background: var(--color-primary);
					color: var(--color-white);
				}
			}

			&::-webkit-scrollbar-track {
				-webkit-box-shadow: inset 0 0 6px var(--color-white);
				box-shadow: inset 0 0 6px var(--color-white);
				background-color: var(--color-white);
			}

			&::-webkit-scrollbar {
				width: 6px;
				background-color: var(--color-white);
			}

			&::-webkit-scrollbar-thumb {
				border-radius: 4px;
				background-color: var(--color-border);
			}
		}

		&.vs--open{
			.vs__dropdown-toggle{
				box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset;
				border-radius: 8px;

				.vs__selected-options{
					.vs__selected{
						position: relative;
					}
				}
			}
		}

		&.form-input--error{
			.vs__dropdown-toggle{
				box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
			}
		}
	}
</style>